import type { AnchorHTMLAttributes } from "react";

import { className as classNameHelper } from "../utilities/className";

import * as styles from "./ChipLink.module.scss";

export interface ChipLinkProps extends Omit<
	AnchorHTMLAttributes<HTMLAnchorElement>,
	"target" | "rel"
> {
	href: string;
	openInNewTab?: boolean;
}

export function ChipLink({
	openInNewTab,
	className,
	children,
	...props
}: ChipLinkProps): JSX.Element {
	return (
		<a
			{...props}
			{...(openInNewTab ? { target: "_blank", rel: "noopener" } : {})}
			{...classNameHelper(styles["chip-link"], className)}
		>
			{children}
		</a>
	);
}
